import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserModel } from '../../models/user/user.model';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../services/controls/shive-notification.service';
import * as fromUserActions from './users.actions';

@Injectable({
  providedIn: 'root',
})
export class UsersHttpService {
  constructor(
    private readonly store: Store,
    private readonly shiveNotificationService: ShiveNotificationService,
    private readonly actions$: Actions,
  ) {
    this.handleHttpCallbacks();
  }

  public getUsers(filterSelf?: boolean): Observable<UserModel[]> {
    this.store.dispatch(
      fromUserActions.fetchUserList({
        payload: filterSelf,
      }),
    );

    return this.actions$.pipe(
      ofType(fromUserActions.setUsers),
      map((result) => result.payload),
      take(1),
    );
  }

  public getUser(userId: number): Observable<UserModel> {
    this.store.dispatch(
      fromUserActions.fetchSingleUser({
        payload: userId,
      }),
    );

    return this.actions$.pipe(
      ofType(fromUserActions.setSingleUser),
      map((result) => result.payload),
    );
  }

  public updateUser(userModel: UserModel): Observable<UserModel> {
    this.store.dispatch(
      fromUserActions.updateUser({
        payload: userModel,
      }),
    );

    return this.actions$.pipe(ofType(fromUserActions.updateUser));
  }

  private handleHttpCallbacks(): void {
    this.actions$
      .pipe(
        ofType(fromUserActions.userAdded, fromUserActions.userUpdated, fromUserActions.userDeleted),
      )
      .subscribe(() => {
        // const message = this.localizationService.getTranslation(payload.responseCode);
        this.shiveNotificationService.show(NotificationType.Success);
      });
  }
}
